<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 91 16"
        fill="none"
        width="91"
        height="16"
        class="transition-all duration-150 hover:scale-125">
        <g clip-path="url(#clip0_3019_1657)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 7.18381L4.83881 7.1912C5.12468 7.12759 5.62014 6.06786 5.72428 5.76514L1.80076 5.75532C1.85176 5.41514 2.02613 5.09424 2.23067 4.81836L6.28779 4.78477L7.09358 3.37133L3.4907 3.3464C4.43817 2.08703 7.30908 1.44207 9.45403 2.3049C9.91381 2.48986 10.8124 2.95028 11.0405 3.34053L7.48322 3.35563L8.24532 4.7844L12.382 4.79096L12.7692 5.72874L8.84511 5.75926L9.5573 7.1756L14.5508 7.19056C14.3827 3.51585 11.0711 0.428879 7.25308 0.43948C3.49324 0.449945 0.193776 3.4773 0 7.18376L0 7.18381Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M70.8617 8.13787C70.5468 5.12057 74.3754 4.93566 74.6734 7.45922C75.0334 10.5087 71.1388 10.7935 70.8617 8.13787ZM71.869 4.19642C67.3154 5.36166 68.7425 12.6432 73.7207 11.4597C78.1544 10.4057 76.7737 2.94137 71.869 4.19642Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M29.8351 5.75026C32.4291 5.12893 33.0334 9.38523 30.7162 9.89164C27.9895 10.4875 27.3697 6.3408 29.8351 5.75026ZM26.6323 8.5279C26.9094 10.4324 28.6128 11.8386 30.9101 11.5119C35.4239 10.8699 34.5775 3.19017 29.4866 4.15384C27.667 4.49824 26.299 6.23772 26.6322 8.5279H26.6323Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M46.5593 11.4753C47.3562 11.6431 48.2976 11.5798 49.0242 11.2977C50.2559 10.8195 51.2176 9.51722 51.1757 7.74529C51.1083 4.89151 48.2511 3.63053 46.2633 4.41401C45.678 4.64469 44.9531 5.20622 44.7578 5.69886C45.113 5.95918 45.5574 6.27645 45.8921 6.53296C46.5057 6.1523 46.8007 5.47769 48.0201 5.79689C48.7926 5.99906 49.2953 6.54861 49.4697 7.37863L46.7645 7.3829C46.901 7.69567 47.0287 7.84424 47.2309 8.15119C47.7537 8.94518 47.5771 8.64346 49.3582 8.71308C49.1142 9.5571 48.2705 10.1631 47.1844 10.0356C46.491 9.95419 46.1554 9.15395 44.821 10.2824C45.0819 10.813 45.7949 11.3145 46.5593 11.4753Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M54.3936 11.5599C54.8067 11.3378 56.1065 7.61442 56.3077 7.14909C56.325 7.16795 56.345 7.19586 56.3547 7.20995C56.6155 7.59079 56.9876 8.6579 57.2551 9.3389C57.4844 9.92287 57.8581 11.0176 58.1608 11.554L60.0484 11.544L57.1237 4.33203L55.5555 4.3413L52.666 11.5441L54.3936 11.5598L54.3936 11.5599Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M80.368 5.89474C81.1942 5.88208 82.2671 5.78271 82.2319 6.76832C82.1991 7.68407 81.1743 7.5584 80.3516 7.54789L80.368 5.89474H80.368ZM78.6572 11.5384L80.3455 11.5509L80.3569 9.12826C81.6324 9.09989 82.3807 9.33208 83.1803 8.53042C83.7507 7.95852 84.1422 7.07623 83.8482 6.00558C83.3226 4.09206 80.846 4.18445 78.6695 4.34967L78.6572 11.5384Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.8115 7.52016L20.8137 5.92617C21.6425 5.84755 22.8742 5.8005 22.6621 6.92907C22.5243 7.66234 21.5181 7.6192 20.8116 7.52016H20.8115ZM19.124 11.5431L20.8011 11.5615L20.8121 9.1533C22.04 8.99074 22.8078 9.35221 23.6072 8.55703C24.1273 8.03979 24.6045 7.06914 24.2885 5.95297C23.752 4.05808 21.1968 4.24942 19.1407 4.34424L19.1241 11.5431H19.124Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.16615 14.9348C5.64265 15.0727 6.04725 15.1952 6.59003 15.1895L6.55003 8.55469L0.0261488 8.55703C-0.0104882 8.99528 0.0472856 9.77532 0.394746 9.99167L4.08826 10.0008C3.66453 10.7408 1.90964 11.9873 1.64763 12.6486C1.99396 12.9533 2.2165 13.275 2.61647 13.5273C3.13352 13.2335 4.56095 11.6205 5.14324 11.0963L5.16615 14.9348V14.9348Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M42.4262 10.2835C40.7845 9.08715 41.0227 10.0068 39.8922 10.0525C37.3637 10.1545 37.0509 6.7093 38.8681 5.9211C40.3243 5.28948 41.013 6.32663 41.3761 6.56001C41.7213 6.23245 42.3051 5.99384 42.4898 5.59657C40.4606 2.94886 36.0918 4.24321 36.0704 7.84517C36.0436 12.3422 41.5685 12.2487 42.4262 10.2835H42.4262Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.39697 15.1102C8.75734 15.1415 9.0743 15.044 9.34058 14.9267C9.57949 14.2599 9.41367 11.0369 9.41472 9.99584L12.7428 10.0124C12.5859 10.5561 12.1773 11.1886 11.8831 11.543C11.5633 11.9282 11.569 11.8421 11.5717 12.5211C11.5732 12.9279 11.575 13.3393 11.585 13.7458C12.6037 13.416 14.5386 10.6483 14.4923 8.95438L14.4805 8.63169L8.04997 8.61328L8.04297 15.1265L8.39697 15.1103V15.1102Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M61.501 5.91007L63.7277 5.91521L63.7469 11.5468L65.4262 11.558L65.4366 5.94367L67.6778 5.89456L67.6797 4.38093L61.5247 4.33008L61.501 5.91007Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M90.0671 5.90785C90.3037 5.43476 90.842 4.83303 90.9999 4.33249L86.1476 4.33203L86.1465 11.5608L87.8182 11.5453L87.8415 5.9129L90.0672 5.9078L90.0671 5.90785Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_3019_1657">
                <rect
                    fill="white"
                    transform="translate(0 0.439453)"
                    width="91"
                    height="14.7875" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
